import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let GeneralInfoCodeComponent = {
    selector: "vcGeneralInfoCode",
    templateUrl: "/angular/components/general/general-info-code.component.html",
    bindings: {
        title: "=?",
        bodyText: "=?",
        buttonText: "=?",
        code: "=?",
    },
    controller: class GeneralInfoCodeController {
        // * bindings for typescript compiler *
        public title?: any;
        public bodyText?: any;
        public buttonText?: any;
        public code?: any;
        // ************************************

        public cancelButtonText: string;
        public confirmButtonText: string;
        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.cancelButtonText =
                this.buttonText && this.buttonText["cancel"]
                    ? this.buttonText["cancel"]
                    : "Cancel";
            this.confirmButtonText =
                this.buttonText && this.buttonText["confirm"]
                    ? this.buttonText["confirm"]
                    : "Confirm";
        }

        confirm(): void {
            this.dialog.hide();
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("general", [])
    .component(GeneralInfoCodeComponent.selector, GeneralInfoCodeComponent);
